export default __webpack_public_path__ + "static/media/tripReportIcon.4c0f33be.svg";